import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex flex-row gap-3 flex-wrap" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createBlock(_component_Card, { class: "custom-card border-b-4 border-h-primary-800 p-4 mt-4" }, {
    header: _withCtx(() => [
      _createElementVNode("h6", null, _toDisplayString(_ctx.$t("labels.generic", { pt: "Corretas", en: "Corrects" })), 1)
    ]),
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.responses, (response, index) => {
          return (_openBlock(), _createElementBlock("p", {
            class: "response",
            key: index
          }, _toDisplayString(response.name), 1))
        }), 128))
      ])
    ]),
    _: 1
  }))
}